
import {
  Obra
} from '../index';


export class ObraPO {
  "ObraId";
  "PO";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraPO`.
   */
  static getModelName() {
    return "ObraPO";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraPO for dynamic purposes.
  **/
  static factory(data) {
    return new ObraPO(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraPO',
      plural: 'ObraPOs',
      path: 'ObraPOs',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "PO": {
          name: 'PO',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraPO.js